export default [
  {
    path: '/login',
    name: 'account-login',
    component: () => import('@/views/Login.vue'),
    meta: {
      protectedLogin: true
    }
  },
  {
    path: '/recuperar-cuenta',
    name: 'account-recovery',
    component: () => import('@/views/RecuperarCuenta.vue'),
    meta: {
      protectedLogin: true
    }
  },
  {
    path: '/registrar/:type?',
    component: () => import ('@/views/Registrar.vue'),
    meta: {
      protectedLogin: true,
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/cuenta.js